import { useState } from 'react';

/**
 * 검증 규칙이 붙는 입력 필드 상태 (값 + 서버 에러 + helperText 병합).
 */
export const useValidatedInput = (
  validate: (value: string) => string | undefined,
) => {
  const [value, setValue] = useState('');
  const [serverError, setServerError] = useState<string>();

  const validationError = validate(value);
  const helperText = serverError ?? (value.length > 0 ? validationError : undefined);

  const onChangeText = (text: string) => {
    setValue(text);
    setServerError(undefined);
  };

  return {
    value,
    onChangeText,
    helperText,
    isValid: !validationError,
    setServerError,
  };
};
